var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "goDieUnlucky",
      style: {
        backgroundImage: "url(" + _vm.goDieUnlucky.background.pictureUrl + ")"
      }
    },
    [
      _c("div", {
        staticClass: "title",
        style: {
          backgroundImage: "url(" + _vm.goDieUnlucky.title.pictureUrl + ")"
        }
      }),
      _c("div", {
        staticClass: "rulesBtn",
        style: {
          backgroundImage: "url(" + _vm.goDieUnlucky.rulesBtn.pictureUrl + ")"
        }
      }),
      _c("div", {
        staticClass: "myPrize",
        style: {
          backgroundImage: "url(" + _vm.goDieUnlucky.myPrize.pictureUrl + ")"
        }
      }),
      _c("div", {
        staticClass: "start",
        style: {
          backgroundImage: "url(" + _vm.goDieUnlucky.start.pictureUrl + ")"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }